export default __webpack_public_path__ + "static/media/earth-blue-marble.7deee995.jpg";